import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ClipboardPencilFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ClipboardPencilFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M12.121 16v2.5h2.5l8.75-8.75a1.768 1.768 0 0 0-2.5-2.5L12.121 16Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="m16.031 19.91-.59.59h-5.33v-5.33l8-8V2.5h-3.03c-.26 3.07-2.83 5.5-5.97 5.5-3.14 0-5.72-2.43-5.97-5.5H.111v16c0 2.76 2.24 5 5 5h8c2.76 0 5-2.24 5-5v-.67l-2.09 2.09.01-.01Z" />
          <path d="M5.121.5V2c0 2.21 1.79 4 4 4s4-1.79 4-4V.5h-8Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ClipboardPencilFilled;